import * as Reflux from "reflux";
export const OrderEntryActions = {
	onCustomerSelected: Reflux.createAction(["onCustomerSelected"]),
	onCustomerChanged: Reflux.createAction(["onCustomerChanged"]),
	onClearTarget: Reflux.createAction(["onClearTarget"]),
	onSubmit: Reflux.createAction(["onSubmit"]),
	onUrlReset: Reflux.createAction(["onUrlReset"]),
	onSelectCardholder: Reflux.createAction(["onSelectCardholder"]),
	deleteSpecificCart: Reflux.createAction(["deleteSpecificCart"]),
};
